import React,{useState, useContext, useEffect} from "react";
import { Dropdown } from "react-bootstrap";
import { Link } from "react-router-dom";
import {useStateContext} from "../../../context/ContextProvider";
import { useNavigate } from 'react-router-dom'
import axios from "axios";
import { Badge } from "react-bootstrap";
 import { Modal } from 'react-bootstrap';
import {
 Form,
  Button,
} from "react-bootstrap";
import { IMAGES, SVGICON } from "../../constant/theme";
import { ThemeContext } from "../../../context/ThemeContext";
import axiosClient from "../../../axios-client";

 

const Header = ({ onNote }) => {
	const { token, setUser, setToken ,user} = useStateContext();
  const [notifications, setNotifications] = useState([]);
	const [headerFix, setheaderFix] = useState(false);
	useEffect(() => {
		window.addEventListener("scroll", () => {
			setheaderFix(window.scrollY > 50);
		});
		  // fetch pending appointments
    
  }, []);

  const userdata = localStorage.getItem('USER_data');
	const userData = JSON.parse(userdata);
	const username = userData.name;
  useEffect(() => {
  const fetchNotifications = () => {
    axiosClient.get("/admin/appointments/pending")
      .then((res) => setNotifications(res.data))
      .catch((err) => console.error("Error fetching notifications", err));
  };
	
  // Fetch once immediately
  fetchNotifications();

  // Set interval to fetch every 30 minutes (30 * 60 * 1000 ms)
  const intervalId = setInterval(fetchNotifications, 30 * 60 * 1000);

  // Cleanup interval on unmount
  return () => clearInterval(intervalId);
}, []);
	   const [notificationList, setNotificationList] = useState(notifications);
// 	 const handleUpdateStatus = (id) => {
//     axios
//       .put(`https://subk.education.com.ly/back/api/appointments/${id}/status`, {
//         status: "accepted",
// 		        admin_note: adminNote, // Add admin's notes
// 		// الحالة المطلوبة
//       })
//       .then((response) => {
//         // تحديث الإشعار في الواجهة المحلية
//         setNotificationList((prevNotifications) =>
//           prevNotifications.map((notification) =>
//             notification.id === id
//               ? { ...notification, status: "accepted" }
//               : notification
//           )
//         );
//         alert("تم قبول الموعد بنجاح");
//         handleClose(); // إغلاق المودال
//       })
//       .catch((error) => {
//         console.error("خطأ في تحديث الحالة:", error);
//       });
//   };
   
  const userid = userData.id;
const handleUpdateStatus = (appointmentId, status) => {
	console.log(' appointmentId ', appointmentId)
		console.log(' status ',status )

  axios
    .put(`https://subk.education.com.ly/back/api/appointments/${appointmentId}/status`, {
      status: status,
      admin_note: adminNote,
	      UserID: userid,

    })
    .then((response) => {
      setNotificationList((prevNotifications) =>
        prevNotifications.map((notification) =>
          notification.id === appointmentId
            ? { ...notification, status: status }
            : notification
        )
      );
      alert(status === "approved" ? "تم قبول الموعد بنجاح" : "تم رفض الموعد بنجاح");
      handleClose();
    })
    .catch((error) => {
      console.error("خطأ في تحديث الحالة:", error);
    });
};

const [adminNote, setAdminNote] = useState("");  // For storing admin notes
	const {background, changeBackground } = useContext(ThemeContext);
	const handleThemeMode = () => {
		if(background.value === 'dark'){
			changeBackground({ value: "light", label: "Light" });
		}else{
			changeBackground({ value: "dark", label: "Dark" });
		}
	}
	const navigate = useNavigate();

  const [show, setShow] = useState(false);      // تحكم إظهار المودال
const [selected, setSelected] = useState(null); // الموعد المختار

// لما تضغط على إشعار
const handleShowDetails = (appointment) => {
  setSelected(appointment); // نخزن بيانات الموعد
  setShow(true);            // نفتح المودال
};

// إغلاق المودال
const handleClose = () => {
  setShow(false);
  setSelected(null);
};
	const onLogout = ev => {
		console.log("token",token)
		setToken(null)
		localStorage.removeItem('USER_PERMISSIONS2');
		localStorage.removeItem('companies');

		ev.preventDefault()
		axios.post('https://subk.education.com.ly/back/api/logout') .then(() => {
			setUser({})
		   setToken(null)
		   navigate('/login');            
			console.log(" aftrer token",token)
		}).catch(function (error) {
		  if (error.response) {
			// The request was made and the server responded with a status code
			// that falls out of the range of 2xx
			console.log(error.response.data);
			console.log(error.response.status);
			console.log(error.response.headers);
		  } else if (error.request) {
			// The request was made but no response was received
			// `error.request` is an instance of XMLHttpRequest in the browser and an instance of
			// http.ClientRequest in node.js
			console.log(error.request);
		  } else {
			// Something happened in setting up the request that triggered an Error
			console.log('Error', error.message);
		  }
		  console.log(error.config);
		});
	  }
  return ( 
    <div className={`header ${headerFix ? "is-fixed" : ""} p-0`}>
      <div className="header-content">
        <nav className="navbar navbar-expand">
          	<div className="collapse navbar-collapse justify-content-between">
				<div className="header-left">					
				</div>
				<div className="header-right d-flex align-items-center">
					
					<ul className="navbar-nav ">
						  {/* 🔔 Notifications Dropdown */}
              {/* <li className="nav-item dropdown notification_dropdown">
              <Dropdown className="header-profile2">
				<Dropdown.Toggle className="nav-link i-false c-pointer" variant="" as="a">
												{SVGICON.BellIcon}
													 <Badge as="a" href="#" bg="primary" className="badge-circle">
             {notifications.length}
          </Badge>					
											</Dropdown.Toggle>
        

                  <Dropdown.Menu align="end" className="notification-dropdown">
                    {notifications.length > 0 ? (
                      notifications.map((n) => (
                        <div key={n.id} className="dropdown-item">
                          <div className="d-flex">
                            <div className="me-2">
                              <i className="fa fa-calendar-check text-success"></i>
                            </div>
                            <div>
                              <strong>{n.customer?.FirstName}</strong> حجز موعد
                              <br />
                              <small>{n.AppointmentDate} - {n.appointment_time}</small>
                            </div>
                          </div>
                        </div>
                      ))
                    ) : (
                      <div className="dropdown-item text-center">لا توجد إشعارات</div>
                    )}
                  </Dropdown.Menu>
                </Dropdown>
              </li> */}
			  <li className="nav-item dropdown notification_dropdown">
  <Dropdown className="header-profile2">
    <Dropdown.Toggle
      className="nav-link i-false c-pointer"
      variant=""
      as="a"
    >
      {SVGICON.BellIcon}
      <Badge as="a" href="#" bg="primary" className="badge-circle">
        {notifications.length}
      </Badge>
    </Dropdown.Toggle>

    <Dropdown.Menu align="end" className="notification-dropdown">
      {notifications.length > 0 ? (
        notifications.map((n) => (
          <div
            key={n.id}
            className="dropdown-item"
            onClick={() => handleShowDetails(n)}
            style={{ cursor: "pointer" }}
          >
            <div className="d-flex">
              <div className="me-2">
                <i className="fa fa-calendar-check text-success"></i>
              </div>
              <div>
                <strong>{n.customer?.FirstName}</strong> حجز موعد
                <br />
                <small>
                  {n.AppointmentDate} - {n.appointment_time}
                </small>
              </div>
            </div>
          </div>
        ))
      ) : (
        <div className="dropdown-item text-center">لا توجد إشعارات</div>
      )}
	  <div className="dropdown-item text-center mt-2">
    <Link
      to="/Notifications"
      style={{ textDecoration: "none", color: "#007bff" }}
    >
      عرض كل الإشعارات
    </Link>
  </div>
    </Dropdown.Menu>
  </Dropdown>

  {/* مودال التفاصيل */}
  <Modal show={show} onHide={handleClose}>
  <div className="modal-content">
                <div className="modal-header">
                        <h1 className="modal-title fs-5" id="exampleModalLabel1">  تفاصيل الموعد</h1>
                        <button type="button" className="btn-close " style={{marginLeft: 0 }}  padding="" onClick={()=>handleClose()}></button>
                    </div>
    <Modal.Body>
      {selected && (
        <>
          <p>
            <b>العميل:</b> {selected.customer?.FirstName}{" "}
            {selected.customer?.LastName}
          </p>
          <p>
            <b>التاريخ:</b> {selected.AppointmentDate} {selected.appointment_time}
          </p>
          <p>
            <b>ملاحظة:</b> {selected.CustomerNote ?? "لا يوجد"}
          </p>
		   {/* Admin Notes Field */}
              <Form.Group className="mb-3" controlId="adminNotes">
                <Form.Label>ملاحظات الإدارة</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={3}
                  value={adminNote}
  onChange={(e) => setAdminNote(e.target.value)}
                    placeholder="أضف ملاحظاتك هنا"
                />
              </Form.Group>
        </>
      )}
    </Modal.Body>
    <Modal.Footer>
   <Modal.Footer>
  <Button variant="success" onClick={() => handleUpdateStatus(selected.AppointmentID, "approved")}>
    قبول
  </Button>
  <Button variant="danger" onClick={() => handleUpdateStatus(selected.AppointmentID, "rejected")}>
    رفض
  </Button>
</Modal.Footer>

    </Modal.Footer>
 </div>

  </Modal>
</li>
							{/* <li className="nav-item dropdown notification_dropdown">
													<Link to={'#'} className="nav-link bell dz-theme-mode"
														onClick={()=>handleThemeMode()}
													>
														{background.value === "dark" ?
															<svg  xmlns="http://www.w3.org/2000/svg"  width="24px" height="24px" viewBox="0 0 24 24" version="1.1" className="svg-main-icon">
																<g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
																	<rect x="0" y="0" width="24" height="24"/>
																	<path d="M12,15 C10.3431458,15 9,13.6568542 9,12 C9,10.3431458 10.3431458,9 12,9 C13.6568542,9 15,10.3431458 15,12 C15,13.6568542 13.6568542,15 12,15 Z" fill="#000000" fillRule="nonzero"/>
																	<path d="M19.5,10.5 L21,10.5 C21.8284271,10.5 22.5,11.1715729 22.5,12 C22.5,12.8284271 21.8284271,13.5 21,13.5 L19.5,13.5 C18.6715729,13.5 18,12.8284271 18,12 C18,11.1715729 18.6715729,10.5 19.5,10.5 Z M16.0606602,5.87132034 L17.1213203,4.81066017 C17.7071068,4.22487373 18.6568542,4.22487373 19.2426407,4.81066017 C19.8284271,5.39644661 19.8284271,6.34619408 19.2426407,6.93198052 L18.1819805,7.99264069 C17.5961941,8.57842712 16.6464466,8.57842712 16.0606602,7.99264069 C15.4748737,7.40685425 15.4748737,6.45710678 16.0606602,5.87132034 Z M16.0606602,18.1819805 C15.4748737,17.5961941 15.4748737,16.6464466 16.0606602,16.0606602 C16.6464466,15.4748737 17.5961941,15.4748737 18.1819805,16.0606602 L19.2426407,17.1213203 C19.8284271,17.7071068 19.8284271,18.6568542 19.2426407,19.2426407 C18.6568542,19.8284271 17.7071068,19.8284271 17.1213203,19.2426407 L16.0606602,18.1819805 Z M3,10.5 L4.5,10.5 C5.32842712,10.5 6,11.1715729 6,12 C6,12.8284271 5.32842712,13.5 4.5,13.5 L3,13.5 C2.17157288,13.5 1.5,12.8284271 1.5,12 C1.5,11.1715729 2.17157288,10.5 3,10.5 Z M12,1.5 C12.8284271,1.5 13.5,2.17157288 13.5,3 L13.5,4.5 C13.5,5.32842712 12.8284271,6 12,6 C11.1715729,6 10.5,5.32842712 10.5,4.5 L10.5,3 C10.5,2.17157288 11.1715729,1.5 12,1.5 Z M12,18 C12.8284271,18 13.5,18.6715729 13.5,19.5 L13.5,21 C13.5,21.8284271 12.8284271,22.5 12,22.5 C11.1715729,22.5 10.5,21.8284271 10.5,21 L10.5,19.5 C10.5,18.6715729 11.1715729,18 12,18 Z M4.81066017,4.81066017 C5.39644661,4.22487373 6.34619408,4.22487373 6.93198052,4.81066017 L7.99264069,5.87132034 C8.57842712,6.45710678 8.57842712,7.40685425 7.99264069,7.99264069 C7.40685425,8.57842712 6.45710678,8.57842712 5.87132034,7.99264069 L4.81066017,6.93198052 C4.22487373,6.34619408 4.22487373,5.39644661 4.81066017,4.81066017 Z M4.81066017,19.2426407 C4.22487373,18.6568542 4.22487373,17.7071068 4.81066017,17.1213203 L5.87132034,16.0606602 C6.45710678,15.4748737 7.40685425,15.4748737 7.99264069,16.0606602 C8.57842712,16.6464466 8.57842712,17.5961941 7.99264069,18.1819805 L6.93198052,19.2426407 C6.34619408,19.8284271 5.39644661,19.8284271 4.81066017,19.2426407 Z" fill="#000000" fillRule="nonzero" opacity="0.3"/>
																</g>
															</svg>
															:
															<svg  xmlns="http://www.w3.org/2000/svg"  width="24px" height="24px" viewBox="0 0 24 24" version="1.1" className="svg-main-icon">
																<g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
																	<rect x="0" y="0" width="24" height="24"/>
																	<path d="M12.0700837,4.0003006 C11.3895108,5.17692613 11,6.54297551 11,8 C11,12.3948932 14.5439081,15.9620623 18.9299163,15.9996994 C17.5467214,18.3910707 14.9612535,20 12,20 C7.581722,20 4,16.418278 4,12 C4,7.581722 7.581722,4 12,4 C12.0233848,4 12.0467462,4.00010034 12.0700837,4.0003006 Z" fill="#000000"/>
																</g>
															</svg>	
														}
													</Link>
												</li> */}
					{/* <li className="nav-item dropdown notification_dropdown ps-3">
					<Dropdown className="header-profile2">
					<Link className="" to="Dashboard_1">
					<Dropdown.Toggle className="nav-link i-false" as="div" data-bs-toggle="tooltip" data-bs-offset="0,4" data-bs-html="true" title=" الصفحة الرئيسية">
									<div className="header-info2 d-flex align-items-center">
										<div className="header-media" style={{verticalalign: 'middle'}}>
										<i class="fa-solid fa-chalkboard"></i> 					
 										</div>
									</div>
								</Dropdown.Toggle></Link>
								</Dropdown>	
					</li> */}
					{/* <li className="nav-item dropdown notification_dropdown ps-3">
					<Dropdown className="header-profile2">
					<Link className="" to="WeddingHall">
					<Dropdown.Toggle className="nav-link i-false" as="div" data-bs-toggle="tooltip" data-bs-offset="0,4" data-bs-html="true" title="قطع الغيار">
									<div className="header-info2 d-flex align-items-center">
										<div className="header-media" style={{verticalalign: 'middle'}}>
 			<i class="fa-solid fa-car-battery"  >
			</i>	 					
 										</div>
									</div>
								</Dropdown.Toggle></Link>
								</Dropdown>	
					</li>
					<li className="nav-item dropdown notification_dropdown ps-3">
					<Dropdown className="header-profile2">
					<Link className="all-notification" to="guaranteetype">
					<Dropdown.Toggle className="nav-link i-false" as="div" data-bs-toggle="tooltip" data-bs-offset="0,4" data-bs-html="true" title="الخدمات ">
									<div className="header-info2 d-flex align-items-center">
										<div className="header-media" style={{verticalalign: 'middle'}}>
										<i class="fa-solid fa-screwdriver-wrench"></i>
																		</div>										
										
									</div>
								</Dropdown.Toggle></Link>
								</Dropdown>	
					</li>	
					<li className="nav-item dropdown notification_dropdown ps-3">
					<Dropdown className="header-profile2">
					<Link className="" to="OrdersList">
					<Dropdown.Toggle className="nav-link i-false" as="div" data-bs-toggle="tooltip" data-bs-offset="0,4" data-bs-html="true" title="كل عمليات الصيانة">
									<div className="header-info2 d-flex align-items-center">
										<div className="header-media" style={{verticalalign: 'middle'}}>
 	 <i class="fa-solid fa-toolbox"> 
			</i>	 					
 										</div>
									</div>
								</Dropdown.Toggle></Link>
								</Dropdown>	
					</li>
					
					<li className="nav-item dropdown notification_dropdown ps-3">
					<Dropdown className="header-profile2">
					<Link className="all-notification" to="Empolyee">
					<Dropdown.Toggle className="nav-link i-false" as="div" data-bs-toggle="tooltip" data-bs-offset="0,4" data-bs-html="true" title="الفنيين">
									<div className="header-info2 d-flex align-items-center">
										<div className="header-media" style={{verticalalign: 'middle'}}>
										<i class="fa-solid fa-users-gear"></i>																	</div>										
										
									</div>
								</Dropdown.Toggle></Link>
								</Dropdown>	
					</li>			
				
					<li className="nav-item dropdown notification_dropdown ps-3">
					<Dropdown className="header-profile2">
					<Link className="all-notification" to="Suppliers">

								<Dropdown.Toggle className="nav-link i-false" as="div" data-bs-toggle="tooltip" data-bs-offset="0,4" data-bs-html="true" title="الموردين">
									<div className="header-info2 d-flex align-items-center">
										<div className="header-media" style={{verticalalign: 'middle'}}>
										<i class="fa-solid fa-store"></i>																</div>										
										
									</div>
								</Dropdown.Toggle></Link>
								</Dropdown>	
					</li>
						<li className="nav-item dropdown notification_dropdown ps-3">
					<Dropdown className="header-profile2">
					<Link className="all-notification" to="CompanyExpenses">
					<Dropdown.Toggle className="nav-link i-false" as="div" data-bs-toggle="tooltip" data-bs-offset="0,4" data-bs-html="true" title="مصروفات الشركة">
									<div className="header-info2 d-flex align-items-center">
										<div className="header-media" style={{verticalalign: 'middle'}}>
										<i class="fa-solid fa-money-bill-trend-up"></i>																								</div>										
										
									</div>
								</Dropdown.Toggle></Link>	
								</Dropdown>	
					</li>	
					<li className="nav-item dropdown notification_dropdown ps-3">
					<Dropdown className="header-profile2">
					<Link className="all-notification" to="CompanyPurchases">
					<Dropdown.Toggle className="nav-link i-false" as="div" data-bs-toggle="tooltip" data-bs-offset="0,4" data-bs-html="true" title="المشتريات">
									<div className="header-info2 d-flex align-items-center">
										<div className="header-media" style={{verticalalign: 'middle'}}>

<i class="fa-solid fa-cart-shopping"></i>																																				
											</div>
									</div>
								</Dropdown.Toggle></Link>
								</Dropdown>	
					</li>
					<li className="nav-item dropdown notification_dropdown ps-3">
					<Dropdown className="header-profile2">
					<Link className="" to="Income">
					<Dropdown.Toggle className="nav-link i-false" as="div" data-bs-toggle="tooltip" data-bs-offset="0,4" data-bs-html="true" title="الدخل">
									<div className="header-info2 d-flex align-items-center">
										<div className="header-media" style={{verticalalign: 'middle'}}>
										<i class="fa-solid fa-hand-holding-dollar"></i>												</div>										
										
									</div>
								</Dropdown.Toggle></Link>	
								</Dropdown>	
					</li>	
					<li className="nav-item dropdown notification_dropdown ps-3"> 
					<Dropdown className="header-profile2">
					<Link className="all-notification" to="Customers">

								<Dropdown.Toggle className="nav-link i-false" as="div" data-bs-toggle="tooltip" data-bs-offset="0,4" data-bs-html="true" title="الزبائن">
									<div className="header-info2 d-flex align-items-center">
										<div className="header-media" style={{verticalalign: 'middle'}}>
										<i class="fa-solid fa-users"></i>																</div>										
										
									</div>
								</Dropdown.Toggle></Link>
								</Dropdown>	
					</li>
								 */}
					
						<li className="nav-item dropdown notification_dropdown ps-3">
							<Dropdown className="header-profile2">
								<Dropdown.Toggle className="nav-link i-false" as="div" data-bs-toggle="tooltip" data-bs-offset="0,4" data-bs-html="true" title="كل عمليات الصيانة">
									<div className="header-info2 d-flex align-items-center">
										<div className="header-media" style={{verticalalign: 'middle'}}>
										{SVGICON.UserSvg}										</div>										
										
									</div>
								</Dropdown.Toggle>
								<Dropdown.Menu align="start"  >
									<div className="card border-0 mb-0"  >
										<div className="card-header py-2">
											<div className="products">
											{SVGICON.UserSvg}												
												<div>
													<h6>{username}</h6>
												</div>	
											</div>
										</div>
										<div className="card-body px-3 py-2">
											 
 											<button className="dropdown-item ai-icon ms-1 products" onClick={onLogout}>
              {SVGICON.Logout} {" "}
							  <span className="ms-2">تسجيل خروج </span>              
            </button>
											
											
										</div>
										
									</div>
									
								</Dropdown.Menu>
							</Dropdown>
						</li>					
					</ul>
				</div>
			
          </div>
        </nav>
      </div>
    </div>
  );
};

export default Header;
